module.exports = __webpack_public_path__ + "static/img/match-bg.d78bb8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match-bg.png
// module id = +hyl
// module chunks = 1